import PropTypes from 'prop-types';

export const addressPropType = {
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state_name: PropTypes.string,
  zipcode: PropTypes.string,
};

export const orderItemsStatusPropType = {
  slug: PropTypes.string,
  name: PropTypes.string,
  quantity: PropTypes.number,
  status: PropTypes.string,
};

export const displayAddressPropType = {
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
  zipcode: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/selectors/shipping.js